<template>
  <div class="down">
    <el-dialog
      title="下载模板" :modal="false" @close="off" width="300px" :show-close="false"
      :close-on-click-modal="false" center label-width='50px' :visible.sync="downShow">
      <el-form :model="form">
        <el-form-item label="省">
          <el-select v-model="place[0]" clearable filterable @change="remoteMethod($event,1)" placeholder="省">
            <el-option v-for="(item,index) in province" :key="index" :label="item.name" :value="item.id">
              <span style="float: left">{{ item.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市">
          <el-select v-model="place[1]" clearable filterable @change="remoteMethod($event,2)" placeholder="市">
            <el-option v-for="(item,index) in city" :key="index" :label="item.name" :value="item.id">
              <span style="float: left">{{ item.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="县">
          <el-select v-model="place[2]" clearable filterable @change="remoteMethod($event,3)" placeholder="县">
            <el-option v-for="(item,index) in county" :key="index" :label="item.name" :value="item.id">
              <span style="float: left">{{ item.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cutDown">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'dowmloadplace',
  props: {
    value: String,
    downShow: Boolean
  },
  data() {
    return{
      place: ['','',''],
      key: 5,
      province: [],
      city: [],
      county: [],
      form: {}
    }
  },
  methods:{
    //选择某项时获取下一项的地点数据
    remoteMethod(value, str) {
      switch(str) {
        case 0 : this.place[1] = this.place[2] =  ''; break;
        case 1 : this.place[1] = this.place[2] =  ''; break;
        case 2 : this.place[2] =  ''; break;
      }
      this.getArea({ value: { areaId: value }, key: str })
    },
    //获取位置
    getArea(data) {
      this.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let response = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : this.province = response; break
            case 1 : this.city = response; break
            case 2 : this.county = response; break
          } 
        } else{
          this._status(res.data)
        }
      })
    },
    //关闭弹窗
    cutDown() {
      this.$emit('cutOff')
    },
    //提交
    submit() {
      if (this.place[ this.place.length - 1 ] == '') {
        return this.$message.info('请选择县')
      } else {
        console.log('%c模板代码：', 'color:red', this.value)
        let requst = {
          areaId: this.place[ this.place.length - 1 ],
          templateType: this.value
        }
        this.$api.templateDown(requst).then(res =>{
          if (res.data.status == 0 ) {
            this.$api.download_doc(res.data.data)
          } else{
            this._status(res.data)
          }
        })
      }
    },
    //关闭弹窗
    off() {
      this.$emit('cutOff',false)
    }
  },
  created() {
    this.getArea({value:{areaId:0},key:0})
  },
}
</script>

<style>
.down .el-dialog {
  height: 350px !important;
  margin-top: 50px!important;
}
</style>
